module.exports = __webpack_public_path__ + "img/abstract4.3fbe7b56.png";